const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8451 5.21375L10.4701 0.21375C10.3513 0.07875 10.1801 0 10.0001 0C9.82008 0 9.64883 0.07875 9.53008 0.21375L5.15508 5.21375C4.99383 5.39875 4.95383 5.66 5.05633 5.88375C5.15758 6.10625 5.38008 6.25 5.62508 6.25H8.12508V14.375C8.12508 14.72 8.40508 15 8.75008 15H11.2501C11.5951 15 11.8751 14.72 11.8751 14.375V6.25H14.3751C14.6201 6.25 14.8426 6.1075 14.9438 5.88375C15.0451 5.66 15.0076 5.3975 14.8451 5.21375Z",
  fill: "#0F76BB"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.875 13.75V17.5H3.125V13.75H0.625V18.75C0.625 19.4412 1.185 20 1.875 20H18.125C18.8162 20 19.375 19.4412 19.375 18.75V13.75H16.875Z",
  fill: "#0F76BB"
});
function SvgFileUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.1f8ccc1e4e8d1ae4f418508e3bf4af76.svg";
export { ForwardRef as ReactComponent };